import { useState, useEffect } from 'react'
import { SectionHeading } from './SectionHeading'
import { Spinner } from '../../../components/Spinner'
import { CarGrid } from "../../../components/CarCards/CarGrid";

export function SimilarCars() {
  const [cars, setCars] = useState([])
  const [currency, setCurrency] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    App.Request.get(`/car_contents/${App.State.carId}/similar_cars.json`)
      .then(({ data, status }) => {
        if (status === 200) {
          setCars(data.cars)
          setCurrency(data.currency)
        } else {
          return null
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div>
      {loading && <Spinner />}

      {!loading && cars.length > 0 && (
        <div id="similar-cars">
          <SectionHeading title={I18n.t('similar_vehicles')} />
          <CarGrid cars={cars} currency={currency} />
        </div>
      )}
    </div>
  )
}
